import { Toaster as Sonner, toast } from "sonner"
import { CheckCircle2, XCircle, Info, AlertTriangle, Loader2 } from "lucide-react"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      icons={{
        success: <CheckCircle2 className="h-[18px] w-[18px] text-[#00FF66]" />,
        error: <XCircle className="h-[18px] w-[18px] text-[#FF6B81]" />,
        info: <Info className="h-[18px] w-[18px] text-white/70" />,
        warning: <AlertTriangle className="h-[18px] w-[18px] text-[#FFB020]" />,
        loading: <Loader2 className="h-[18px] w-[18px] animate-spin text-[#00FF66]" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast !rounded-xl !border !border-white/10 !bg-[#0d0f12]/95 !text-white !backdrop-blur-xl !shadow-[0_20px_60px_-20px_rgba(0,0,0,0.85)] !font-semibold !text-[13px]",
          title: "!font-semibold",
          description: "!text-white/50 !font-medium",
          actionButton: "!bg-[#00FF66] !text-black !rounded-full !font-bold",
          cancelButton: "!bg-white/10 !text-white/70 !rounded-full",
          success: "!border-[#00FF66]/25",
          error: "!border-[#FF6B81]/25",
          warning: "!border-[#FFB020]/25",
          info: "!border-white/10",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
